import type { Siblings as SiblingsDto } from "@nabla/api";
import { shellCopy } from "../copy.ts";
import { Link } from "./Link.tsx";
import styles from "./Header.module.css";

export function Siblings({ siblings }: { readonly siblings: SiblingsDto }) {
  const arrow = (direction: "prev" | "next", glyph: string, label: string) => {
    const target = siblings[direction];
    return target ? (
      <Link href={target.href} kind="sibling" className={styles.arrow} aria-label={`${label}: ${target.name}`} data-irmao={direction}>
        {glyph}
      </Link>
    ) : (
      <span className={`${styles.arrow} ${styles.off}`} aria-hidden="true">
        {glyph}
      </span>
    );
  };
  return (
    <div className={styles.siblings}>
      {arrow("prev", "‹", shellCopy.navegacao.anterior)}
      <span className={styles.count}>{shellCopy.navegacao.irmaos(siblings.index, siblings.count)}</span>
      {arrow("next", "›", shellCopy.navegacao.proximo)}
    </div>
  );
}
